import i from "@mui/icons-material/VisibilityOffOutlined";
import d from "@mui/icons-material/VisibilityOutlined";
import { styled as s, InputAdornment as l, IconButton as f } from "@mui/material";
import a from "../../share/apeiron/ApeironTextField.js";
import { useState as c } from "react";
import { jsx as o } from "react/jsx-runtime";
const m = s(i)`
  color: #ffffff;
`, p = s(d)`
  color: #ffffff;
`, x = (e) => {
  const [t, n] = c(!1);
  return /* @__PURE__ */ o(a, {
    ...e,
    type: t ? "text" : "password",
    InputProps: {
      endAdornment: /* @__PURE__ */ o(l, {
        position: "end",
        children: /* @__PURE__ */ o(f, {
          onClick: () => {
            n(!t);
          },
          onMouseDown: (r) => {
            r.preventDefault();
          },
          edge: "end",
          children: t ? /* @__PURE__ */ o(m, {}) : /* @__PURE__ */ o(p, {})
        })
      })
    }
  });
};
export {
  x as default
};
//# sourceMappingURL=FormControlledPassword.js.map
